import { useLang } from '@/i18n';
import { useEffect, useState, useRef, useMemo, memo } from 'react';
import css from './index.module.scss';
import EcoVideo from 'eco-design/base/eco-video';
import EFTheRoadJp from './svg/EFTheRoadJp';
import EFTheRoadJp375 from './svg/EFTheRoadJp_375';
import EcoSpace from 'eco-design/base/eco-space';

import { getIsPadWidth } from '@elem/utils/devices';

const B: React.FC = () => {
    const { t } = useLang('theProduct.SectionA');

    const boxRef = useRef<HTMLElement>(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) return;
            // sceneB1: 文字从大到小的动画（200vh-400vh）
            const sceneB1 = AniContainer.create({
                triggerElement: `.rv-sectionA`,
                triggerHook: 1,
                offset: '100%',
                duration: '100%',
                syncFromTo: [['.rv-sectionA .sectionA-banner-box', { scale: 1, opacity: 1 }, { scale: 6, opacity: 0 }]],
            });

            const sceneB2 = AniContainer.create({
                triggerElement: `.rv-sectionA`,
                triggerHook: 1,
                offset: '270%',
                duration: '100%',
                syncFromTo: [['.rv-sectionA .sectionA-text-box', { opacity: 0 }, { opacity: 1 }]],
            });

            return () => {
                const scenes = [sceneB1, sceneB2];
                scenes?.map((item: any) => item.destroy());
            };
        }
    }, []);

    useEffect(() => {
        setIsMobile(getIsPadWidth());
    }, []);

    const renderSVG = useMemo(() => {
        return isMobile ? <EFTheRoadJp375 id="sloganId2" /> : <EFTheRoadJp id="sloganId" />;
    }, [isMobile]);

    return (
        <section className={`${css.SectionA} rv-sectionA GtmModuleData-section`} id="rv-sectionA" data-section-id={'on-the-road-AniSectionA'} ref={boxRef}>
            <div className="sticky pc">
                <div className={`sectionA-banner-box`}>{renderSVG}</div>
                <div className="sectionA-video">
                    <EcoVideo
                        pc="https://websiteoss.ecoflow.com/upload/video/1761875567675/sectiona_video.mp4"
                        poster="https://websiteoss.ecoflow.com/upload/image/1761894321391/sectiona_1.jpg"
                        autoPlay={true}
                        loop={true}
                    />
                </div>
                <div className="sectionA-text-box">
                    <div className="text-box-container">
                        <div className="text-box-label">{t('label')}</div>
                        <div className="text-box-title">{t('title')}</div>
                        <div className="text-box-desc">{t('desc')}</div>
                    </div>
                </div>
            </div>

            <div className="mobile-container">
                <EcoSpace />

                <div className="mobile-text-box">
                    <div className="mobile-text-container">
                        <div className="mobile-text-label">{t('label_h5')}</div>
                        <div className="mobile-text-title">{t('title_h5')}</div>
                    </div>
                </div>
                <div className="mobile-video">
                    <EcoVideo
                        pc="https://websiteoss.ecoflow.com/upload/video/1761891941547/sectiona_video_h5.mp4"
                        poster="https://websiteoss.ecoflow.com/upload/image/1761894321393/sectiona_2.jpg"
                        autoPlay={true}
                        loop={true}
                    />
                </div>
            </div>
        </section>
    );
};

export default memo(B);
